// i18n.js - Survey translations (English default, Spanish if browser is es-*)

const translations = {
  en: {
    // Progress
    progress: 'Progress',

    // Question validation
    questionRequired: 'This question must be answered',

    // Rating
    notRated: 'Not rated',
    ratingOf: (value) => `${value} out of 5`,

    // Text placeholder
    textPlaceholder: 'Write your answer here...',

    // Emoji labels
    emojiLeft: 'Terrible',
    emojiRight: 'Excellent',

    // Comments section
    additionalComments: 'Additional comments (optional)',
    commentsPlaceholder: 'If you wish, you can leave an additional comment here...',

    // Submit button
    submitButton: 'Submit answers',
    submitting: 'Submitting...',
    submitted: 'Submitted! Redirecting...',
    completeAll: 'Complete all questions to submit the survey',

    // Success / error messages
    thankYou: 'Thank you for completing the survey!',
    errorLoading: 'An error occurred while loading the survey. Please try again.',
    errorSubmitting: 'An error occurred while submitting your answers. Please try again.',
    surveyNotFound: 'Survey not found or the link is invalid.',
    surveyNotActive: 'This survey is not currently available.',
    validateAll: 'Please answer all questions before submitting the survey.',

    // Already submitted screen
    alreadySubmittedTitle: 'You already completed this survey!',
    alreadySubmittedMessage: 'You have already submitted your answers. Thank you for your participation.',
    retakeSurvey: 'Answer again',

    // Footer
    poweredBy: 'Powered by',

    // Back button
    backToHome: 'Back to home',
    startSurvey:'Start now'
  },

  es: {
    progress: 'Progreso',
    questionRequired: 'Esta pregunta debe ser respondida',
    notRated: 'Sin calificar',
    ratingOf: (value) => `${value} de 5`,
    textPlaceholder: 'Escribe tu respuesta aquí...',
    emojiLeft: 'Pésimo',
    emojiRight: 'Excelente',
    additionalComments: 'Comentarios adicionales (opcional)',
    commentsPlaceholder: 'Si deseas, puedes dejar un comentario adicional aquí...',
    submitButton: 'Enviar respuestas',
    submitting: 'Enviando...',
    submitted: '¡Enviado! Redirigiendo...',
    completeAll: 'Completa todas las preguntas para enviar la encuesta',
    thankYou: '¡Gracias por completar la encuesta!',
    errorLoading: 'Ocurrió un error al cargar la encuesta. Por favor, intenta nuevamente.',
    errorSubmitting: 'Ocurrió un error al enviar tus respuestas. Por favor, intenta nuevamente.',
    surveyNotFound: 'Encuesta no encontrada o el enlace es inválido.',
    surveyNotActive: 'Esta encuesta no está disponible actualmente.',
    validateAll: 'Por favor, responde todas las preguntas antes de enviar la encuesta.',

    // Already submitted screen
    alreadySubmittedTitle: '¡Ya respondiste esta encuesta!',
    alreadySubmittedMessage: 'Ya enviaste tus respuestas anteriormente. Gracias por tu participación.',
    retakeSurvey: 'Responder de nuevo',

    poweredBy: 'Desarrollado por',
    backToHome: 'Volver al inicio',
  },
};

/**
 * Returns the translation object based on the browser's language.
 * Defaults to English unless the browser language starts with 'es'.
 */
export const getTranslations = () => {
  const lang = navigator.language || navigator.userLanguage || 'en';
  return lang.toLowerCase().startsWith('es') ? translations.es : translations.en;
};

export default translations;